import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor( private http: HttpClient) { }

  getCountry(): Observable<any> {
    return this.http.get(`delivery-countries`);
  }
  getState(countryId : number): Observable<any> {
    return this.http.get(`delivery-states?country_id=${countryId}`);
  }
  getLga(stateId : number): Observable<any> {
    return this.http.get(`delivery-lgas?state_id=${stateId}`);
  }

  getDeliveryRate(orderAmount:number , countryId : number, stateId : number , lgaId? : number): Observable<any> {
    return this.http.get(`delivery-cost?order_amount=${orderAmount}&country_id=${countryId}&state_id=${stateId}&lga_id=${lgaId}`);
  }

  retrieveLeadTime( product_ids:number[], countryId : number, stateId : number , lgaId? : number): Observable<any> {
    const headers = new HttpHeaders({'Content-type': 'application/json'});
    return this.http.post('lead-time/retrieve-lead-time',{countryId, stateId, lgaId, product_ids}, {headers});
  }

  checkOrderStatus(orderId : number): Observable<any> {
    return this.http.get(`orders/${orderId}`);
  }
}
